<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Justice as a Virtue</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT"><a id="page_v"></a><a id="page_vi">Contents</a></p><a id="page_vi">
</a><p class="Toc1a"><a id="page_vi"></a><a href="#/xhtml/preface#prf-001" id="prf001"><i>Preface</i></a></p>
<p class="Toc1"><a href="#/xhtml/acknowledgment#ack-001" id="ack001"><i>Acknowledgments</i></a></p>
<p class="Toc2"><a href="#/xhtml/chapter001" id="ch001"><b>1.<span class="space">Justice as a Virtue</span></b></a></p>
<p class="Toc3"><a href="#/xhtml/chapter001#ch-001s1" id="ch001s1">Preliminary Considerations</a></p>
<p class="Toc3"><a href="#/xhtml/chapter001#ch-001s2" id="ch001s2">The Theoretical Framework</a></p>
<p class="Toc3"><a href="#/xhtml/chapter001#ch-001s3" id="ch001s3">The Virtues as Normative Ideals</a></p>
<p class="Toc3"><a href="#/xhtml/chapter001#ch-001s4" id="ch001s4">An Overview of the Virtue of Justice</a></p>
<p class="Toc3"><a href="#/xhtml/chapter001#ch-001s5" id="ch001s5">Reason, Revelation, and Justice</a></p>
<p class="Toc2"><span href="#/xhtml/chapter002" id="ch002" title="Link target outside of Sample"><b>2.<span class="space">Virtues and Vices of the Will</span></b></span></p>
<p class="Toc3"><span href="#/xhtml/chapter002#ch-002s1" id="ch002s1" title="Link target outside of Sample">The Will as a Causal Principle</span></p>
<p class="Toc3"><span href="#/xhtml/chapter002#ch-002s2" id="ch002s2" title="Link target outside of Sample">The Will as the Principle of Voluntary Actions</span></p>
<p class="Toc3"><span href="#/xhtml/chapter002#ch-002s3" id="ch002s3" title="Link target outside of Sample">Habits of the Will</span></p>
<p class="Toc3"><span href="#/xhtml/chapter002#ch-002s4" id="ch002s4" title="Link target outside of Sample">Justice as a Perfection of the Will</span></p>
<p class="Toc2"><span href="#/xhtml/chapter003" id="ch003" title="Link target outside of Sample"><b>3.<span class="space">Justice as a Moral Ideal</span></b></span></p>
<p class="Toc3"><span href="#/xhtml/chapter003#ch-003s1" id="ch003s1" title="Link target outside of Sample">Justice, Equality, and Right</span></p>
<p class="Toc3"><span href="#/xhtml/chapter003#ch-003s2" id="ch003s2" title="Link target outside of Sample">Equality, Right, and Obligation</span></p>
<p class="Toc3"><span href="#/xhtml/chapter003#ch-003s3" id="ch003s3" title="Link target outside of Sample">Justice, Practical Reason, and First Principles</span></p>
<p class="Toc3"><span href="#/xhtml/chapter003#ch-003s4" id="ch003s4" title="Link target outside of Sample">The Common Good, Political Rule, and the Ideal of Equality</span></p>
<p class="Toc2"><a id="page_viii"></a><span href="#/xhtml/chapter004" id="ch004" title="Link target outside of Sample"><b>4.<span class="space">From Ideal to Law</span></b></span></p>
<p class="Toc3"><span href="#/xhtml/chapter004#ch-004s1" id="ch004s1" title="Link target outside of Sample">Norm, Precept, and Act</span></p>
<p class="Toc3"><span href="#/xhtml/chapter004#ch-004s2" id="ch004s2" title="Link target outside of Sample">Justice and the Moral Emotions</span></p>
<p class="Toc3"><span href="#/xhtml/chapter004#ch-004s3" id="ch004s3" title="Link target outside of Sample">Norms of Nonmaleficence</span></p>
<p class="Toc3"><span href="#/xhtml/chapter004#ch-004s4" id="ch004s4" title="Link target outside of Sample">The Place of Discernment in the Activities of Justice</span></p>
<p class="Toc2"><span href="#/xhtml/chapter005" id="ch005" title="Link target outside of Sample"><b>5.<span class="space">The Perfections of the Will</span></b></span></p>
<p class="Toc3"><span href="#/xhtml/chapter005#ch-005s1" id="ch005s1" title="Link target outside of Sample">Reason and the Virtues</span></p>
<p class="Toc3"><span href="#/xhtml/chapter005#ch-005s2" id="ch005s2" title="Link target outside of Sample">Value, Morality, and Perfections of the Will</span></p>
<p class="Toc3"><span href="#/xhtml/chapter005#ch-005s3" id="ch005s3" title="Link target outside of Sample">Commitment and Regard, Two Aspects of Justice</span></p>
<p class="Toc3"><span href="#/xhtml/chapter005#ch-005s4" id="ch005s4" title="Link target outside of Sample">Conclusion</span></p>
<p class="Toc1b"><span href="#/xhtml/bibliography#bib-001" id="bib001" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="Toc1"><span href="#/xhtml/index001#idx-001" id="idx001" title="Link target outside of Sample"><i>Name Index</i></span></p>
<p class="Toc1"><span href="#/xhtml/index002#idx-002" id="idx002" title="Link target outside of Sample"><i>Subject Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d4d63b6c